import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Accordion, Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Own constants/actions/components
import { getExclusivityBannerAction } from 'services/actions/exclusivity-banner';
import StepsLineComponent from 'components/steps-line';
import noPoints from 'assets/not-points.svg';
import cartMini from 'assets/cart-mini.svg';
import { ACCUMULATE_POINTS_LINK } from 'constants/Constants';

const InsufficientPoints = () => {
  const dispatch = useDispatch();

  const handleClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  useEffect(() => {
    dispatch(getExclusivityBannerAction('NO_POINTS'));
  }, []);

  return (
    <>
      <div className="sticky-resumen-mobile d-lg-none d-xl-none disabled opacity-70">
        <Accordion className="ticket-mobile">
          <Card>
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="text-left not-link"
                onClick={handleClick}>
                <img src={cartMini} alt="shop-cart-mini" className="mr-15" />
                <h2 className="d-inline-block">Resumen de tu pedido</h2>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <p className="text-tangaroa">Aún no tienes seleccionado ningún campo</p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>

      <Container fluid className="bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <StepsLineComponent itemActive={0} />
            </Col>
          </Row>
          <Row className="justify-content-center py-60">
            <Col lg={1} />
            <Col lg={7} className="text-center">
              <h2 className="text-tangaroa">¡Lo sentimos!</h2>
              <h3 className="py-30 text-tangaroa">
                En este momento no cuentas con Puntos Aeroméxico Rewards suficientes
                para poder adquirir tu Experiencia. Sigue acumulando Puntos.
              </h3>
              <img src={noPoints} alt="shopping-cart-error" />
              <h3 className="py-30 text-tangaroa">
                Ingresa aquí para conocer donde puedes seguir acumulando Puntos.
              </h3>
              <div className="d-flex flex-column align-items-center">
                <a href={ACCUMULATE_POINTS_LINK} className="btn btn-primary mb-3">
                  Conoce más
                </a>
                <Link to="/" className="text-tangaroa link">En otro momento</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default InsufficientPoints;
